import React from 'react'
import PropTypes from 'prop-types'

import { Form, DateInput, Button, ErrorText, Label, TimeInput, Dropdown, TextArea } from 'components/Forms'
import Text from 'components/Text'
import style from './style.module.scss'

const PRE_ALARM_REMINDER_OPTIONS = [
  { value: 0, label: 'Off' },
  { value: 5, label: '05 Minutes Before' },
  { value: 10, label: '10 Minutes Before' },
  { value: 15, label: '15 Minutes Before' },
  { value: 30, label: '30 Minutes Before' },
]

const EMERGENCY_NOTIFICATION_DELAY_OPTIONS = [
  { value: 0, label: 'No Delay' },
  { value: 5, label: '05 Minutes After Alarm' },
  { value: 10, label: '10 Minutes After Alarm' },
  { value: 15, label: '15 Minutes After Alarm' },
  { value: 30, label: '30 Minutes After Alarm' },
  { value: 60, label: '1 Hours After Alarm' },
]

AlarmDetailsForm.propTypes = {
  values: PropTypes.object,
  onSubmit: PropTypes.func,
  isProcessing: PropTypes.bool,
}

function AlarmDetailsForm(props) {
  const { values, onSubmit, isProcessing } = props

  return (
    <Form values={{
      ...values,
      alarmDate: values?.startTime,
      alarmTime: values?.startTime,
      }} onSubmit={onSubmit} className={style.wrapper}>
      {({ onChange, values, error }) =>
          <React.Fragment>
            <div className={style.fields}>
              <Label>Date</Label>
              <DateInput
                name='alarmDate'
                value={values.alarmDate}
                onChange={onChange}
                minDate={new Date()}
              />
            </div>
            <div className={style.fields}>
              <Label>Alarm Time</Label>
              <TimeInput
                name='alarmTime'
                value={values.alarmTime}
                onChange={onChange}
                minDate={new Date()}
              />
            </div>
            <div className={style.fields}>
              <Label>Pre-alarm Reminder</Label>
              <Dropdown
                name='preAlarmReminderMinutes'
                value={values.preAlarmReminderMinutes}
                onChange={onChange}
                options={PRE_ALARM_REMINDER_OPTIONS}
                className={style.dropdown}
              />
            </div>
            <div className={style.fields}>
              <Label>Emergency Contact Delay</Label>
              <Dropdown
                name='emergencyNotificationDelayMinutes'
                value={values.emergencyNotificationDelayMinutes}
                onChange={onChange}
                options={EMERGENCY_NOTIFICATION_DELAY_OPTIONS}
                className={style.dropdown}
              />
            </div>
            <div>
              <Label>Where are you going?</Label>
              <Text className={style.modalText}>We'll share this with your emergency contacts if your alarm goes off and you don't respond.</Text>
              <TextArea
                name='locationDetails'
                value={values.locationDetails}
                onChange={onChange}
                placeholder='Enter where you are going and when you expect to return'
                className={style.textarea}
              />
            </div>
            {error && <ErrorText>{error}</ErrorText>}

            <Button type='submit' disabled={isProcessing}>Save</Button>
          </React.Fragment>
      }
    </Form>
  )
}

export default AlarmDetailsForm    
